export enum PaymentMethod {
  Payroll = 'Payroll',
  ACH = 'ACH',
}
